var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main_div" }, [
    _c("div", { staticClass: "flex" }, [
      _c(
        "div",
        { staticClass: "drug_select" },
        [
          _c(
            "v-select",
            {
              ref: "vue_select",
              attrs: {
                label: "title",
                placeholder: "Препарат",
                filterable: false,
                options: _vm.options,
              },
              on: { input: _vm.select, search: _vm.onSearchDrug },
              nativeOn: {
                keypress: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.preventDefault()
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "option",
                  fn: function (option) {
                    return [
                      _c("div", { staticClass: "d-center" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(option.title) +
                            " :: " +
                            _vm._s(option.veshchestvo) +
                            "\n            "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "selected-option",
                  fn: function (option) {
                    return [
                      _vm._v(
                        "\n            " + _vm._s(option.title) + "\n          "
                      ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.drug,
                callback: function ($$v) {
                  _vm.drug = $$v
                },
                expression: "drug",
              },
            },
            [
              _c("template", { slot: "no-options" }, [
                _vm._v(
                  "\n            введите название препарата..\n          "
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _vm.drug
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.drug.qty,
                  expression: "drug.qty",
                },
              ],
              staticClass: "form-control border-r-0",
              attrs: { type: "number", name: "qty", placeholder: "Количество" },
              domProps: { value: _vm.drug.qty },
              on: {
                change: _vm.updateQty,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.drug, "qty", $event.target.value)
                },
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.errors.has("qty")
          ? _c("small", { staticClass: "form-text text-danger" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.errors.first("qty")) + "\n        "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.drug && _vm.drug.holod
        ? _c("div", { staticClass: "cool_mark" }, [
            _c("i", { staticClass: "icon icon-snowflake" }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.drug && _vm.getDiscountPrices(_vm.drug)
        ? _c("div", { staticClass: "cool_mark" }, [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: {
                    show: _vm.toolOpen,
                    placement: "bottom-center",
                    content: _vm.getDiscountPrices(_vm.drug, true),
                    classes: ["discount_tooltip"],
                  },
                  expression:
                    "{ show: toolOpen, placement: 'bottom-center', content: getDiscountPrices(drug, true) ,classes: ['discount_tooltip']}",
                },
              ],
              staticClass: "icon icon-fa icon-fa-percent",
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.drug
        ? _c(
            "div",
            [
              _c(
                "v-popover",
                {
                  attrs: {
                    "auto-hide": true,
                    popoverClass: "info_drug_popover_wrapper",
                    popoverInnerClass: "info_drug_popover",
                    placement: "left",
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info btn-xs border-r-0",
                      staticStyle: { height: "38px" },
                      on: {
                        click: function ($event) {
                          return _vm.getDrugInfo(_vm.drug.id, true)
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon-fa icon-fa-info" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "popover" },
                    [
                      _vm.drugData[_vm.drug.id] &&
                      _vm.drugData[_vm.drug.id][_vm.siteId] &&
                      _vm.drugData[_vm.drug.id][_vm.siteId].info
                        ? [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.printDrugInfo(
                                    _vm.drugData[_vm.drug.id][_vm.siteId].info
                                  )
                                ),
                              },
                            }),
                          ]
                        : [
                            _vm._v(
                              "\n              Загрузка ....\n            "
                            ),
                          ],
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "close-popover",
                              rawName: "v-close-popover",
                            },
                          ],
                          staticClass: "btn btn-theme btn-sm",
                        },
                        [_vm._v("Закрыть")]
                      ),
                    ],
                    2
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.drug
      ? _c("div", { staticClass: "price_info" }, [
          _vm.drug.komplekt && _vm.drug.komplekt != 1
            ? _c("p", [
                _c("i", {
                  staticClass: "icon-fa icon-fa-info-circle drugset_info",
                }),
                _vm._v(" комплект "),
                _c("strong", [_vm._v(_vm._s(_vm.drug.komplekt))]),
                _vm._v(" * "),
                _c("strong", { staticClass: "actual_drug_price" }, [
                  _vm._v(_vm._s(_vm.drugActualPrice)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("p", [
            _c("span", [
              _vm._v("страна поставки: "),
              _c("strong", [
                _vm._v(_vm._s(_vm.drug.import_country.full_country)),
              ]),
            ]),
            _vm._v(" "),
            _vm.drug.valid_dates && _vm.drug.valid_dates.length
              ? _c("span", [
                  _vm._v("срок годности: "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.printValidDates(_vm.drug.valid_dates))),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("span", [
              _vm._v(" стоимость: "),
              _c("strong", { staticClass: "actual_drug_price" }, [
                _vm._v(
                  _vm._s(
                    _vm.drugActualPrice *
                      (_vm.drug.komplekt && _vm.drug.komplekt != 1
                        ? _vm.drug.komplekt
                        : 1)
                  ) + " "
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.drug.lgot_price
              ? _c("span", { staticClass: "badge badge-success" }, [
                  _vm._v("Льготная доставка"),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }